// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1lavS","image":"styles_image__rgt77","overlay":"styles_overlay__2H2Yv","logo":"styles_logo__17TkH"};